import { ReactNode } from 'react';
import { SetOptional } from '@trukt/types/TypeFest';
import { ProgressNotifierItemData } from './components/ProgressNotifier';

export type UpdateProgressNotifierItemData = Partial<Omit<ProgressNotifierItemData, 'id'>>;

export interface ProgressNotifierContextData {
  state: UpdateProgressNotifierItemData[];
  dispatchNotification: (item: SetOptional<ProgressNotifierItemData, 'id'>) => string;
  dispatchNotifications: (items: ProgressNotifierItemData[]) => void;
  removeNotification: (id: string) => void;
  removeNotifications: (id: string[]) => void;
  updateNotification: (id: string, item: UpdateProgressNotifierItemData) => void;
  handleError: (label: string, error: unknown | Error, id?: string) => string;
}

export interface ProgressNotifierContextProps {
  children: ReactNode;
}

export enum ProgressNotfierActionTypes {
  DISPATCH_NOTIFCATION = 'dispatchNotification',
  DISPATCH_NOTIFCATIONS = 'dispatchNotifications',
  REMOVE_NOTIFICATION = 'removeNotification',
  REMOVE_NOTIFICATIONS = 'removeNotifications',
  UPDATE_NOTIFICATION = 'updateNotification',
}

export type ProgressNotfierActions =
  | {
      type: ProgressNotfierActionTypes.DISPATCH_NOTIFCATION;
      payload: ProgressNotifierItemData;
    }
  | { type: ProgressNotfierActionTypes.DISPATCH_NOTIFCATIONS; payload: ProgressNotifierItemData[] }
  | { type: ProgressNotfierActionTypes.REMOVE_NOTIFICATION; payload: { id: string } }
  | { type: ProgressNotfierActionTypes.REMOVE_NOTIFICATIONS; payload: { ids: string[] } }
  | {
      type: ProgressNotfierActionTypes.UPDATE_NOTIFICATION;
      payload: { id: string; item: UpdateProgressNotifierItemData };
    };
